import { render, staticRenderFns } from "./alopecia.vue?vue&type=template&id=5d70f09e&scoped=true&"
import script from "./alopecia.vue?vue&type=script&lang=js&"
export * from "./alopecia.vue?vue&type=script&lang=js&"
import style0 from "./alopecia.vue?vue&type=style&index=0&id=5d70f09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70f09e",
  null
  
)

export default component.exports